/**
 * 微服务发现工具
 * 通过msLogin获取其他微服务的地址信息
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var ServiceDiscovery = /** @class */ (function () {
    function ServiceDiscovery(config) {
        this.serviceCache = new Map();
        this.defaultTimeout = 5000;
        this.defaultCacheTimeout = 60000; // 1分钟缓存
        this.config = __assign({ timeout: config.timeout || this.defaultTimeout, cacheTimeout: config.cacheTimeout || this.defaultCacheTimeout }, config);
    }
    /**
     * 获取所有微服务列表
     */
    ServiceDiscovery.prototype.getAllServices = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response, result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch("".concat(this.config.msLoginUrl, "/api/microservices"), {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                signal: AbortSignal.timeout(this.config.timeout)
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("\u83B7\u53D6\u5FAE\u670D\u52A1\u5217\u8868\u5931\u8D25: ".concat(response.status, " ").concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        result = _a.sent();
                        if (!result.success) {
                            throw new Error("\u83B7\u53D6\u5FAE\u670D\u52A1\u5217\u8868\u5931\u8D25: ".concat(result.message || '未知错误'));
                        }
                        // 转换为标准格式
                        return [2 /*return*/, result.data.map(function (service) { return ({
                                serviceName: service.name || service.key,
                                displayName: service.displayName || service.name,
                                frontendUrl: service.url,
                                backendUrl: service.backendUrl,
                                status: service.status === 'online' ? 'online' : 'offline',
                                healthStatus: service.healthStatus || false
                            }); })];
                    case 3:
                        error_1 = _a.sent();
                        console.error('ServiceDiscovery: 获取微服务列表失败:', error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 根据服务名获取特定微服务信息
     */
    ServiceDiscovery.prototype.getService = function (serviceName) {
        return __awaiter(this, void 0, Promise, function () {
            var cached, response, result, service, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cached = this.serviceCache.get(serviceName);
                        if (cached && Date.now() - cached.timestamp < this.config.cacheTimeout) {
                            return [2 /*return*/, cached.service];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(this.config.msLoginUrl, "/api/microservices/").concat(serviceName), {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                signal: AbortSignal.timeout(this.config.timeout)
                            })];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) {
                            if (response.status === 404) {
                                return [2 /*return*/, null];
                            }
                            throw new Error("\u83B7\u53D6\u5FAE\u670D\u52A1\u4FE1\u606F\u5931\u8D25: ".concat(response.status, " ").concat(response.statusText));
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        result = _a.sent();
                        if (!result.success) {
                            throw new Error("\u83B7\u53D6\u5FAE\u670D\u52A1\u4FE1\u606F\u5931\u8D25: ".concat(result.message || '未知错误'));
                        }
                        service = {
                            serviceName: result.data.name || serviceName,
                            displayName: result.data.displayName || result.data.name,
                            frontendUrl: result.data.url,
                            backendUrl: result.data.backendUrl,
                            status: result.data.status === 'online' ? 'online' : 'offline',
                            healthStatus: result.data.healthStatus || false
                        };
                        // 更新缓存
                        this.serviceCache.set(serviceName, {
                            service: service,
                            timestamp: Date.now()
                        });
                        return [2 /*return*/, service];
                    case 4:
                        error_2 = _a.sent();
                        console.error("ServiceDiscovery: \u83B7\u53D6\u5FAE\u670D\u52A1 ".concat(serviceName, " \u4FE1\u606F\u5931\u8D25:"), error_2);
                        throw error_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取微服务的后端API地址
     */
    ServiceDiscovery.prototype.getServiceBackendUrl = function (serviceName) {
        return __awaiter(this, void 0, Promise, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getService(serviceName)];
                    case 1:
                        service = _a.sent();
                        return [2 /*return*/, (service === null || service === void 0 ? void 0 : service.backendUrl) || null];
                }
            });
        });
    };
    /**
     * 获取微服务的前端地址
     */
    ServiceDiscovery.prototype.getServiceFrontendUrl = function (serviceName) {
        return __awaiter(this, void 0, Promise, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getService(serviceName)];
                    case 1:
                        service = _a.sent();
                        return [2 /*return*/, (service === null || service === void 0 ? void 0 : service.frontendUrl) || null];
                }
            });
        });
    };
    /**
     * 检查微服务是否在线
     */
    ServiceDiscovery.prototype.isServiceOnline = function (serviceName) {
        return __awaiter(this, void 0, Promise, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getService(serviceName)];
                    case 1:
                        service = _a.sent();
                        return [2 /*return*/, (service === null || service === void 0 ? void 0 : service.healthStatus) || false];
                }
            });
        });
    };
    /**
     * 清除缓存
     */
    ServiceDiscovery.prototype.clearCache = function () {
        this.serviceCache.clear();
    };
    /**
     * 清除特定服务的缓存
     */
    ServiceDiscovery.prototype.clearServiceCache = function (serviceName) {
        this.serviceCache.delete(serviceName);
    };
    return ServiceDiscovery;
}());
export { ServiceDiscovery };
// 默认配置的服务发现实例
var defaultMsLoginUrl = process.env.REACT_APP_MSLOGIN_URL || 'http://localhost:50090';
export var serviceDiscovery = new ServiceDiscovery({
    msLoginUrl: defaultMsLoginUrl
});
// 便捷函数
export var getServiceBackendUrl = function (serviceName) {
    return serviceDiscovery.getServiceBackendUrl(serviceName);
};
export var getServiceFrontendUrl = function (serviceName) {
    return serviceDiscovery.getServiceFrontendUrl(serviceName);
};
export var isServiceOnline = function (serviceName) {
    return serviceDiscovery.isServiceOnline(serviceName);
};
